// extracted by mini-css-extract-plugin
module.exports = {"logo":"TopbarCalculator_logo__2CTVJ"};